import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id E11E01A9-8231-456F-AF61-82A069BBDAAB
 * name music-rest-whole
 * version: 3.9.97
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/music-rest-whole.svg
 * tags
 * - Music 
 */
export const MusicRestWholeIcon = createSvgIcon(<><path d="M18 10H16V14H8V10H6V9H18V10Z" /></>, 'MusicRestWholeIcon');
export default MusicRestWholeIcon